import { hFetch } from '@/lib/hfetch';
import type { MonthlyMarketingBudgetEntity } from '@/api/entity_types/MonthlyMarketingBudget';

export type ListMonthlyMarketingBudgetsResponse = {
  active_budget: MonthlyMarketingBudgetEntity | null;
  records: MonthlyMarketingBudgetEntity[];
};

export const listMonthlyMarketingBudgets = async () => {
  return await hFetch<ListMonthlyMarketingBudgetsResponse>({
    url: '/api/monthly_marketing_budgets',
  });
};
